export const UserKeys = {
    UUID: "uuid",
    EMPLOYEE_UUID: "employeeUuid",
    REGION: "region",
    TOKEN: "token",
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    PROFILE_PICTURE_URL: "profilePictureUrl",
    DEPARTMENT: "department",
    EMPLOYMENT_POSITION: "employmentPosition",
    EMAIL: "email",
    ACCESS_CODE: "accessCode",
    PERMISSIONS: "permissions",
    FEATURE_FLAGS: "featureFlags",
    PHONE_NUMBER: "phoneNumber",
    BIRTH_DATE: "birthDate",
    IS_ACTIVE: "isActive",
    SUBSCRIPTION_MODE: "subscriptionMode",
    SUBSCRIPTION_WAS_EVER_PAID: "subscriptionWasEverPaid",
    SUBSCRIPTION_IS_VALID: "subscriptionIsValid",
    IS_CLIENT: "isClient",
    LEADERSHIP_ROLES: "leadershipRoles",
    COMPANY_NAME: "companyName",
    APP_VARIANT: "appVariant",
    COMPANY_ABN: "abn",
    IS_CUSTOMIZE_COMPLETE: "isCustomizeComplete",
    COUNTRY_CODE: "countryCode",
    ENABLED_CLIENT_LICENSE: "enabledClientLicense",
    COMPANY_LOGO_URL: "companyLogoUrl",
    COMPANY_LOGO_UPDATED_AT: "companyLogoUpdatedAt",
    COMPANY_BACKGROUND_COLOR: "backgroundColor",
    COMPANY_PRIMARY_COLOR: "primaryColor",
    MATRIX_USER_ID: "matrixUserId",
    CHAT_PRESENCE_OVERRIDE: "chatPresenceOverride",
    CUSTOM_NAME_DIRECTORY: "customDirectoryName",
    CUSTOM_NAME_MY_QUOTES: "customMyQuotesName",
    CUSTOM_NAME_BODY_AND_MIND: "customBodyAndMindName",
    CUSTOM_NAME_USER_GROUPS_CLIENTS: "customUserGroupClients",
    CUSTOM_NAME_USER_GROUPS_EMPLOYEES: "customUserGroupEmployees",
    CUSTOM_NAME_SALES_AND_PROMOTIONS: "customSalesAndPromotionsName",
    CUSTOM_NAME_DIGITAL_MEMBER_CARDS: "customMembershipCardName",
    LICENSE_TIER: "licenseTier",
    REQUIRED_DOCUMENTS: "requiredDocuments",
};

export const SubscriptionMode = {
    ACTIVE: "ACTIVE",
    DEMO: "DEMO",
    NONE: "NONE"
};

export const SubscriptionPaymentMode = {
    Upfront: "upfront",
    PaymentPlan: "paymentPlan"
};
